import Blog1 from "@/assets/blog-1.jpeg";
import Blog2 from "@/assets/blog-2.jpeg";
import Blog3 from "@/assets/blog-3.jpeg";
import Blog4 from "@/assets/blog-finc.jpeg";
import Blog5 from "@/assets/Blog5.jpeg";

import { useParams } from "react-router-dom";

type BlogPost = {
  id: number;
  quote?: {
    quoteInfo: string;
    author: string;
  };
  title: string;
  description: string;
  description2?: string;
  date?: string;
  img: string;
  questions?: {
    question: string;
    ans: string;
  }[];
  quote2?: {
    quoteInfo: string;
    author: string;
  };
};

const blogs: BlogPost[] = [
  {
    id: 1,
    quote: {
      quoteInfo:
        '"The best investment you can make is in yourself… but the next best is one that grows quietly while you live your life."',
      author: "Inspired by Warren Buffett",
    },
    title:
      "In Uncertain Times, Can SIPs in Mutual funds Be Your Financial Umbrella?",
    date: "August 18, 2023",
    img: Blog1,
    description:
      "In today’s world of rising uncertainty ;  wars, trade tensions, and unpredictable markets ;  many people wonder if it’s even the right time to invest. The truth is, the world has always had its share of turbulence. But there’s a quiet, consistent way to grow your wealth ;  even while you sleep. ",
    description2:
      "A Systematic Investment Plan (SIP) allows you to invest small, fixed amounts in mutual funds regularly, without worrying about market timing. It’s perfect for anyone who wants to invest steadily, build wealth over time, and doesn’t have the time or expertise to monitor markets daily.",
    questions: [
      {
        question:
          "The world seems so uncertain right now ;  war, trade tensions, market volatility. Should we even be investing now?",
        ans: "Yes, the world feels shaken. And when fear rises, markets often react more to emotion than to logic. But seasoned investors know ;  uncertainty is not new. It comes and goes. What matters is how you respond. And you don’t need to be an expert to invest wisely.",
      },
      {
        question:
          "But I don’t have time to study the market or time it right. What can I do?",
        ans: "That’s exactly where a Systematic Investment Plan (SIP) in mutual funds steps in. It’s like planting a tree ;  little by little, rain or shine. SIPs help you invest small amounts regularly, removing the pressure to “time” the market.",
      },
      {
        question:
          "How does SIP work for someone like me ;  with a job, family, and no time to research?",
        ans: " SIPs are designed for people like you. Once we understand your financial goals, timeline, and comfort with risk, we select the right mutual funds. You just keep investing steadily ;  the power of compounding does the rest.",
      },
      {
        question: "But is this really safe in times like these?",
        ans: " SIPs don’t promise overnight success. But over time, they balance out the market’s ups and downs. Think of it like a disciplined friend who helps you stay on track, even when the world feels off-balance.",
      },
      {
        question: "Is it too late to start?",
        ans: " It’s never too late to take control of your financial future. The best time to start was yesterday. The next best time is NOW.",
      },
    ],
    quote2: {
      quoteInfo: "In the middle of every difficulty lies opportunity.",
      author: "Albert Einstein",
    },
  },
  {
    id: 2,
    title: "“Finding the Right Mutual Fund; A Journey of Dreams and Decisions”",
    date: "August 18, 2023",
    img: Blog2,
    description:
      "Life is a series of choices; some small, some life-changing. Choosing the right mutual fund is one such decision that shapes your financial journey, just like picking the right path on an uncertain road.",
    description2:
      "Today, the world feels unpredictable. Inflation is rising, global tensions loom, and stock markets swing like a pendulum. Investors in India are feeling the heat too, with market fluctuations making it hard to decide where to put your money. In such times, making the right investment choice isn’t just about numbers; it’s about emotions, aspirations, and peace of mind.",
    questions: [
      {
        question: "How do I even start choosing a mutual fund?",
        ans: "Start by asking yourself: What am I investing for? A child's education? A dream home? A peaceful retirement? Your investment should be tied to your dreams, not just market trends.",
      },
      {
        question: "I’m scared of losing money. How do I handle risk?",
        ans: " It’s okay to be scared. The key is knowing yourself. Are you someone who loses sleep over small market dips? Or can you handle a few bumps for long-term growth? Matching your mutual fund to your risk comfort level is like choosing between a calm lake and a thrilling river ride.",
      },
      {
        question: " Does time really matter when picking a fund?",
        ans: "Absolutely! If your goal is just a couple of years away, you wouldn’t want to gamble it on a rollercoaster stock market. But if you have 10-15 years, equities might be your best bet. Think of it like planting a tree; the longer you wait, the stronger it grows.",
      },
      {
        question: "Does the fund house and fund manager really matter?",
        ans: "Would you trust an unknown driver on a dangerous road? No, right? A well-managed fund, backed by an experienced team, ensures your money is in safe hands. Look for consistency, not just flashy returns.",
      },
      {
        question: "How do I ensure I’m making the right choice?",
        ans: "Picture yourself years from now, looking back at this decision. Would you regret taking unnecessary risks? Or regret being too cautious? The best fund is the one that aligns with your life, your dreams, and your heart’s peace.",
      },
    ],
    quote2: {
      quoteInfo:
        "Investing isn’t just about wealth; it’s about building a future you can look forward to with confidence. Choose wisely, and let your money grow along with your dreams.",
      author: "Uma Kumaravelan",
    },
  },
  {
    id: 3,
    title: "Money, Motherhood & Mentorship; Women Shape Generations",
    img: Blog3,
    description:
      "March 8th, Women’s Day, made me pause and reflect on the silent yet powerful role women, especially mothers, play in shaping a family's financial behaviour. Growing up, my mother was the backbone of our household’s finances. My father, busy with work, left the responsibility of running the household and managing investments to her. With no online banking 40 years ago, I was given the task of handling banking transactions and investments. This early exposure opened the doors to financial analysis, and today, I am a financial planner, guiding people towards secure investments and life planning. <br/> <br/> In my professional journey, I have discovered that financial habits often stem from childhood experiences. Mothers, knowingly or unknowingly, leave a lasting impact on their children’s financial behaviour. Here are two inspiring stories that reaffirm the role of mothers as financial influencers. <br/> <br/> Sheena grew up in a middle-class family, where her mother, Meera, instilled the habit of saving early on. Meera gifted Sheena and her brother a piggy bank and encouraged them to save the money they received as pocket money or gifts. This simple yet powerful lesson shaped their financial mindset. When they started earning, saving was their first priority, followed by expenses; a habit that ensured their financial stability. <br/> <br/> Rahul’s father, an army officer, tragically lost his life in a terrorist attack in Kashmir. His mother, Yashoda, was offered a government job and a pension. Choosing to dedicate herself to raising Rahul and his brother, she declined the job and managed their household solely on the pension. She ensured her children received a good education while maintaining financial discipline. Rahul, now in a responsible position, attributes his strong financial planning skills to his mother’s wisdom; teaching him how to make the most of available resources. <br/> <br/> Women are natural planners; whether in managing a home, finances, or earning an income. However, in the course of responsibilities, many women step back from handling finances. On this Women’s Day, I urge every woman to take charge of their own finances and family. Discuss finances openly with your family so that children can pick up good financial habits early. Engage in financial conversations, play family games like Monopoly to make learning fun, and support other women who need guidance. By embracing financial awareness and collaboration, women can not only secure their own future but also empower generations to come.",
    quote2: {
      quoteInfo:
        "Owning your power as a woman means taking responsibility for your financial future.",
      author: "Suze Orman",
    },
  },
  {
    id: 4,
    img: Blog4,
    title:
      "Workplace Financial Planning – A Step Towards Peace of Mind at Work",
    quote: {
      quoteInfo:
        "It's not just about saving money; it's about feeling financially secure and mentally free while you work.",
      author: "Aakash Panchal",
    },
    description: `We all work hard to earn a living, take care of our families, and secure our future. But even with a good salary, many of us feel stressed about money; be it managing monthly expenses, repaying loans, or planning for our children’s education.<br/>
  This is where Workplace Financial Planning makes a real difference. It’s not just about saving money; it's about feeling financially secure and mentally free while you work.<br/>
  In simple words, it means having someone at your workplace who can guide you in managing your money better; through saving, investing, budgeting, and protecting your family with the right insurance.<br/>
  Let’s answer some common questions people have, especially in the Indian context.`,
    description2: `Take the example of Rajesh, a 35-year-old software engineer in Mumbai. Despite earning ₹20 lakhs annually, he had no savings. After attending a workplace financial planning session, he started an SIP, took term insurance, and planned his daughter’s school fees. Today, he sleeps peacefully and feels confident about his future.`,
    questions: [
      {
        question: "What is Workplace Financial Planning?",
        ans: [
          "Workplace financial planning is when your employer ties up with a financial expert to help you plan your finances; right from budgeting, saving, and investing to insurance and retirement planning. It's like having a personal money coach at work.",
          "This could be done through:",
          [
            "Workshops on money habits",
            "One-on-one financial counselling",
            "Monthly investment reviews",
            "Tax-saving tips and more",
          ],
        ],
      },
      {
        question: "Is this common in India?",
        ans: [
          "Not yet common, but growing fast.",
          "Many progressive companies in India; especially in metro cities like Mumbai, Bangalore, and Hyderabad; are now realizing that financial stress affects employee focus, energy, and productivity. So they are bringing in financial wellness programs as part of employee benefits.",
          "Companies like Infosys, Tata, and many startups have started offering sessions on financial planning, debt management, SIPs, insurance awareness, and retirement planning.",
        ],
      },
      {
        question: "How does it benefit employees?",
        ans: [
          "When employees receive financial guidance:",
          [
            "They worry less about money",
            "Take better decisions about loans and investments",
            "Feel more secure about their future",
            "Are able to save and invest regularly",
            "Work with a free mind and focused energy",
          ],
          "Just like we go to a doctor for health, a financial planner at work becomes your guide for financial health. You don’t need to be a finance expert; you just need the right direction.",
        ],
      },
      {
        question: "How can companies implement it?",
        ans: [
          "Companies can start small by:",
          [
            "Partnering with a Certified Financial Planner",
            "Organizing monthly or quarterly financial literacy sessions",
            "Offering free one-on-one money consultations for employees",
            "Sharing simple weekly money tips",
            "Including this in their employee wellness policy",
          ],
          "Some even create a Financial Help Desk where employees can drop by for advice, just like the HR desk.",
        ],
      },
      {
        question: "Who is qualified to do this?",
        ans: [
          "A Certified Financial Planner (CFP) or a SEBI-registered Investment Advisor is ideal. In India, many financial advisors and wellness consultants now specialize in workplace financial planning.",
          "Look for someone who:",
          [
            "Gives unbiased advice",
            "Understands Indian salary structures, PF, tax, loans, LICs, SIPs",
            "Communicates in simple terms",
            "Cares about people, not just profits",
          ],
        ],
      },
      {
        question: "Why should companies care?",
        ans: [
          "Because financial stress is silent but serious. An employee who is stressed about EMI or credit card dues may be physically present but mentally distracted.",
          "When companies care for their team’s financial well-being:",
          [
            "Productivity improves",
            "Attrition reduces",
            "Loyalty increases",
            "The workplace becomes more positive",
          ],
          "Happy employees = Happy company.",
        ],
      },
      {
        question:
          "What are some topics covered in Workplace Financial Planning?",
        ans: [
          [
            "Salary budgeting",
            "Emergency funds",
            "Insurance planning (health, life, term plans)",
            "SIPs and Mutual Funds",
            "Retirement planning",
            "Children’s education planning",
            "Debt management",
            "Tax-saving investments (ELSS, PPF, NPS)",
          ],
        ],
      },
      {
        question: "A Real-Life Story",
        ans: [
          "Take the example of Rajesh, a 35-year-old software engineer in Mumbai. Despite earning ₹20 lakhs annually, he had no savings. After attending a workplace financial planning session, he started an SIP, took term insurance, and planned his daughter’s school fees. Today, he sleeps peacefully and feels confident about his future.",
        ],
      },
      {
        question: "Final Thoughts",
        ans: [
          "Workplace financial planning is not a luxury; it’s a necessity in today’s fast-paced, uncertain world. When money is managed well, peace of mind follows.",
          "If you're an employer reading this, consider investing in your team’s financial wellness. If you're an employee, ask your company for it; it’s your right to work stress-free.",
          "Let’s make India not just a growing economy, but a financially healthy one.",
        ],
      },
    ],
  },
  {
    id: 5,
    img: Blog5,
    title: "What If Something Goes Wrong?",
    description: "A Candid Conversation on Women and Financial Planning",
    questions: [
      {
        question:
          "Why did we host a financial planning session only for women at Shelf Drilling?",
        ans: [
          "March is a month to celebrate women – their strength, resilience, and multitasking skills.",
          "We wanted to go beyond flowers and sweets. So, we organized a session that truly empowers: financial literacy for women.",
          "Our goal? To help women take charge of their own money decisions.",
        ],
      },
      {
        question:
          "What was the most common concern women shared during the session?",
        ans: [
          "The most soul-touching moment came when a woman said, “I let my husband handle investments because I’m scared; what if I make a mistake?”",
          "This fear is real, and very common. Many women know how to run a home, plan a vacation, stretch a monthly budget; yet feel unsure about handling investments.",
        ],
      },
      {
        question: "Isn’t that ironic? Women are already managing so much!",
        ans: [
          "Exactly! Women are excellent at multitasking, juggling work, kids, home, and elderly care.",
          "Then why not finances? The truth is; they can. They just need the right knowledge and support to build money confidence.",
        ],
      },
      {
        question: "Why is financial planning important for women?",
        ans: [
          "Because life is unpredictable. Whether single, married, or widowed; financial independence for women is not a luxury, it’s a necessity.",
          "When women understand financial products, goals, and cash flows, they become stronger decision-makers; for themselves and their families.",
        ],
      },
      {
        question: "So, what holds them back?",
        ans: [
          "Apprehension. Fear of making the wrong choice. And the conditioning that “money matters are for men.”",
          "But guess what? Women are already budgeting groceries, school fees, EMIs; they understand money flow.",
          "What they need is the courage to start and the guidance to stay on track.",
        ],
      },
      {
        question: "What was our key message to the women during the session?",
        ans: [
          "Don’t hand over the remote control of your life.",
          "Be part of money conversations at home. Ask questions.",
          "Learn about SIPs, insurance, mutual funds, and retirement planning.",
          "Your dreams deserve to be planned for.",
        ],
      },
      {
        question: "How can women begin their financial journey?",
        ans: [
          [
            "Start small. Learn about 2–3 financial products.",
            "Set short- and long-term goals.",
            "Track income, expenses, and savings monthly.",
            "Talk to a financial planner who speaks your language.",
            "Most importantly, believe that you can.",
          ],
        ],
      },
      {
        question: "One message you want every woman to remember?",
        ans: [
          "You already know how to care. Now, care for your future.” You don’t need to be perfect; you just need to begin. Financial planning is not about numbers. It’s about freedom, dignity, and choices. And every woman deserves that.",
        ],
      },
    ],
  },
];

export default function SingleBlog() {
  const { id } = useParams<{ id?: string }>();

  if (id === undefined) return <div>Wrong blog ID</div>;

  const blogId = Number(id);
  const blog = blogs.find((b) => b.id === blogId);

  return (
    <div className="min-h-screen p-1 md:p-6 flex justify-center">
      <div className="min-h-screen p-3 md:p-6 mt-40 md:mt-[6vw] max-w-6xl">
        <img
          src={blog?.img}
          alt={blog?.title}
          className="w-full max-h-[550px] object-cover"
        />

        {blog?.quote && (
          <blockquote className="mt-5 text-xl italic text-gray-600 border-l-4 border-blue-500 pl-4 mb-6">
            {blog?.quote.quoteInfo}
            <br />
            <span className="block text-sm mt-2 text-right">
              ;  {blog?.quote.author}
            </span>
          </blockquote>
        )}

        <h2 className="text-3xl font-semibold mb-4 mt-10">{blog?.title}</h2>

        {blog?.description.split("<br/>").map((line, index) => (
          <p key={index} className="mt-2">
            {line}
          </p>
        ))}

        {blog?.description2 && (
          <p className="mt-10 mb-6">{blog.description2}</p>
        )}

        <div className="space-y-6">
          {blog?.questions?.map((question, index) => (
            <div key={index}>
              <p className="font-semibold text-blue-700">
                <span className="font-bold">Q:{index + 1}</span>{" "}
                {question.question}
              </p>

              {Array.isArray(question.ans) ? (
                question.ans.map((part, i) =>
                  Array.isArray(part) ? (
                    <ul key={i} className="list-disc ml-6 mt-2">
                      {part.map((item, j) => (
                        <li key={j}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p key={i} className="mt-1">
                      {part}
                    </p>
                  ),
                )
              ) : (
                <p className="mt-1">{question.ans}</p>
              )}
            </div>
          ))}
        </div>

        {blog?.quote2 && (
          <blockquote className="mt-10 text-xl italic text-gray-600 border-l-4 border-green-500 pl-4">
            {blog.quote2.quoteInfo}
            <br />
            <span className="block text-sm mt-2 text-right">
              ;  {blog.quote2.author}
            </span>
          </blockquote>
        )}
      </div>
    </div>
  );
}
